import { render } from "./LogoutAlert.vue?vue&type=template&id=8cc370f6&scoped=true"
import script from "./LogoutAlert.vue?vue&type=script&lang=js"
export * from "./LogoutAlert.vue?vue&type=script&lang=js"

import "./LogoutAlert.vue?vue&type=style&index=0&id=8cc370f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cc370f6"]])

export default __exports__